import $ from 'jquery';
import {EN_KO} from '../helpers/GlobalsHelper';
import MediaHelper from '../helpers/MediaHelper';
import {disablePageScroll, enablePageScroll, clearQueueScrollLocks} from "scroll-lock";


const offcanvas_new = function() {

	$( '.js-offcanvas-new' ).each( function() {
		var $elem = $( this );

		var offcanvas_is_facet = $elem.hasClass( 'mdl_offcanvas-new--facet-filter' );

		$elem.find( '.mdl_offcanvas-new__content > .mdl_offcanvas-new__level' ).addClass( 'is-level-active' );

		$elem.on( 'click', '.mdl_offcanvas-item.has_submenu > .menu_item_name, .mdl_offcanvas-item.is-facet > .menu_item_name', function( e ) {
			e.preventDefault();
			var $this = $( this );
			var $root = $( this ).parent();

			var $level = $this.next( '.mdl_offcanvas-new__level' );
			var $level_before = $level.parent().closest( '.mdl_offcanvas-new__level' );

			if ( $root.hasClass( 'is-cat-facet' ) ) {

				var $input = $root.find( 'input:checked' ).first();

				// Get active Level and open until.
				if ( $input.length ) {
					$level = $input.closest( '.mdl_offcanvas-new__level' );
					$level_before = $level.parent().closest( '.mdl_offcanvas-new__level' );

					// Update all Parents until the Input
					if ( $level.length ) {
						$level.parentsUntil( $root ).filter( '.mdl_offcanvas-new__level' ).addClass( 'is-level-open' ).removeClass( 'is-level-active' );
					}
				}
			}

			if ( $level.length ) {
				$this.closest( '.mdl_offcanvas-new__content' ).find( '.mdl_offcanvas-new__level.is-level-active' ).removeClass( 'is-level-active' );
				$level.addClass( 'is-level-open is-level-active' );

				$level.trigger( 'open_submenu.en', {
					'is_root':  $level_before.hasClass( 'mdl_offcanvas-new__level--root' ),
				} );
			}
		} );

		$elem.on( 'click', '.mdl_offcanvas-new__level-header-back', function( e ) {
			e.preventDefault();
			var $level = $( this ).closest( '.mdl_offcanvas-new__level' );
			var $level_before = $level.parent().closest( '.mdl_offcanvas-new__level' );

			$level.removeClass( 'is-level-open is-level-active' );
			$level_before.addClass( 'is-level-active' );

			$level.trigger( 'close_submenu.en', {
				'is_root':  $level_before.hasClass( 'mdl_offcanvas-new__level--root' ),
			} );
		} );

		if ( offcanvas_is_facet ) {
			offcanvas_new_facet( $elem );
		}
	} );

	// Trigger event if offcanvas menu mobile is opened (is needed by TAO)
	$( document ).on( 'click', '#js_trigger_offcanvas_menu_mobile', function() {
		var offcanvas_menu_mobile = $( '#offcanvas_menu_mobile' );
		if ( offcanvas_menu_mobile.hasClass( 'is-visible' ) ) {
			offcanvas_menu_mobile.trigger( 'open_menu.en' );
		}
	} );
};

const offcanvas_new_facet = function( $elem ) {

	var $offcanvas_overlay = $( '.offcanvas-new_overlay' );
	var $offcanvas_facet_item = $elem.find( '.mdl_offcanvas-item.is-facet' ); // eslint-disable-line no-unused-vars
	var $offcanvas_facet_submit = $elem.find( '.mdl_offcanvas-new__submit-button' );

	// On change of any input.
	$elem.on( 'change', '.mdl_offcanvas-item.is-facet input:not(".input--facet-search")', function() {
		$( this ).trigger( 'change_submenu.en' );
	} );

	// On search.
	$elem.on( 'keyup', '.mdl_offcanvas-item.is-facet .input--facet-search', function() {
		var $content = $( this ).closest( '.mdl_offcanvas-new__level-content' );
		var search_term = $( this ).val().toLowerCase();

		var all_terms = $content.find( 'input:not(".input--facet-search")' );
		all_terms.each( function() {
			const $this = $( this );
			var term_name = decodeURIComponent( $this.data( 'label' ) || $this.val() ).toLowerCase();

			// Show/Hide terms (not) containing the given search term
			$this.parent().toggleClass( 'en_hidden', term_name.indexOf( search_term ) === -1 );
		} );
	} );

	// Reset all facets and searchboxes
	$elem.on( 'click', '.js-trigger-reset-all-facet-filter', function() {
		$elem.trigger( 'facetfilter_change_reset.en' );
	} );

	// Reset certain facet and searchbox
	$elem.on( 'click', '.js-trigger-reset-facet-filter', function() {
		var $facet = $( this ).closest( '.mdl_offcanvas-item.is-facet' );

		// Reset current Filters to initial.
		$facet.find( '.input--facet-search' ).val( '' ).trigger( 'keyup' );

		$( this ).trigger( 'reset_submenu.en', $facet.data( 'identifier' ) );
	} );

	// On submit.
	$elem.on( 'click', '.mdl_offcanvas-new__submit-button', function( ev ) {

		var $facet_level = $elem.find( '.mdl_offcanvas-new__level.is-level-open' );
		var $facet = $facet_level.parent(); // eslint-disable-line no-unused-vars
		ev.preventDefault();

		// Check if a facet is currently open
		if ( $facet_level.length ) {

			$facet_level.removeClass( 'is-level-open' );
			$facet_level.trigger( 'submit_submenu.en' );

			$elem.trigger( 'facetfilter_change_update.en', $elem.serializeJSON() );

			// If no facet is open, then submit the offcanvas filter
		} else {

			// Submit the Element.
			$elem.submit();
		}
	} );

	$elem.on( 'submenu_loaded.acl', function() {
		$elem.find( 'input[type=range]' ).trigger( 'input' );
	} );

	$elem.on( 'submit', function( ev ) {

		ev.preventDefault();
		$elem.trigger( 'facetfilter_change_save.en', $elem.serializeJSON() );
		$offcanvas_overlay.trigger( 'click' );
	} );

	( function() {
		var initState = false;
		var prevState = false;
		var prevBoxes = [];

		function setButton( $level ) {

			var currState;

			if ( $level && ! $level.is( '.mdl_offcanvas-new__level--root' ) ) {
				currState = $level.serialize();

				// Update Facet Submit Button.
				$offcanvas_facet_submit.toggleClass( 'en_button--disabled', prevState === currState );
				$offcanvas_facet_submit.text( $offcanvas_facet_submit.attr( 'data-button-text-submenu' ) );

				// Update Facet Level Reset Button.
				if ( $level.data( 'active' ) ) {
					currState = ! $level.find( ':input:checked' ).is( $level.data( 'active' ) );
				}

				$level.find( '.mdl_offcanvas-new__level-header-reset' ).toggleClass( 'en_hidden', ! currState );
			} else {
				currState = $elem.serialize();

				// Update Form Level Reset Button.
				$elem.find( '.js-trigger-reset-all-facet-filter' ).toggleClass( 'en_hidden', currState === initState );

				// Update Form Submit Button.
				$offcanvas_facet_submit.removeClass( 'en_button--disabled' );
				$offcanvas_facet_submit.text( $offcanvas_facet_submit.attr( currState === initState ? 'data-button-text-noresults' : 'data-button-text-results' ) );
			}
		}

		// When the menu gets initially rendered.
		$elem.on( 'render_menu.acl', function() {
			initState = $( this ).serialize();

			setButton();
		} );

		// When the menu gets re-rendered.
		$elem.on( 'update_menu.acl', function() {

			$elem.find( '.is-cat-facet' ).each( function() {
				var $fieldset = $( this ).children( 'fieldset.mdl_offcanvas-new__level' );
				$fieldset.data( 'active', $fieldset.find( ':input:checked' ) );
			} );

			setButton();
		} );

		// When we open a submenu.
		$elem.on( 'open_submenu.en', 'fieldset.mdl_offcanvas-new__level', function( ev ) {
			ev.stopPropagation();

			prevState = $( this ).serialize();
			prevBoxes = $( this ).find( ':input:checked' );

			setButton( $( this ) );
		} );

		// When we close a submenu via Backbutton.
		$elem.on( 'close_submenu.en', 'fieldset.mdl_offcanvas-new__level', function( ev, ev_data ) {
			ev.stopPropagation();

			if ( ev_data.is_root ) {
				setButton();
			}

			if ( ev.target === this ) {
				// Reset checkboxes
				$( this ).find( ':input[type=checkbox], :input[type=radio]' ).prop( 'checked', false ).filter( prevBoxes ).prop( 'checked', true );
			}
		} );

		// When a checkbox or radio button in the submenu changes.
		$elem.on( 'change_submenu.en', 'fieldset.mdl_offcanvas-new__level', function( ev ) {
			ev.stopPropagation();

			setButton( $( this ) );
		} );

		// When the reset Filters Button gets clicked.
		$elem.on( 'reset_submenu.en', 'fieldset.mdl_offcanvas-new__level', function( ev ) {
			ev.stopPropagation();

			$( this ).find( ':input[type=checkbox],:input[type=radio]' ).prop( 'checked', false );

			if ( $( this ).data( 'active' ) ) {
				$( this ).data( 'active' ).prop( 'checked', true );
			}

			setButton( $( this ) );
		} );

	} )();
};

const initBodyScrollLock = function() {
	EN_KO.elements.$html.on( 'load_menu.tao, render_menu.acl', function() {
		if ( EN_KO.elements.$html.hasClass( 'is-offcanvas-open' ) ) {
			$( '.mdl_offcanvas-new.is-visible .mdl_offcanvas-new__level-content' ).each( function( index, element ) {
				disablePageScroll( element );
			} );
		} else if ( EN_KO.elements.$html.hasClass( 'en_has_offcanvas' ) ) {
			disablePageScroll( document.querySelector( '.offcanvas.en_is_active .offcanvas_inner' ) );
		}
	} );

	if ( MediaHelper.matches( null, 'desktop' ) ) {
		EN_KO.elements.$html.on( 'classclickadd', function( e, data ) {
			if ( data.className == 'is-offcanvas-open' ) {
				$( '.mdl_offcanvas-new.is-visible .mdl_offcanvas-new__level-content' ).each( function( index, element ) {
					disablePageScroll( element );
				} );
			}
		} ).on( 'classclickremove', function( e, data ) {
			if ( data.className == 'is-offcanvas-open' ) {
				clearQueueScrollLocks();
				enablePageScroll();
			}
		} );
	}
};

export {
	offcanvas_new,
	offcanvas_new_facet,
	initBodyScrollLock
};
